import { render } from "./ChatThreadParentMessage.vue?vue&type=template&id=0092ce3e"
import script from "./ChatThreadParentMessage.vue?vue&type=script&lang=js"
export * from "./ChatThreadParentMessage.vue?vue&type=script&lang=js"

import "./ChatThreadParentMessage.vue?vue&type=style&index=0&id=0092ce3e&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__